import React from 'react'
import { RoomProvider } from './context/RoomContext'
import { MediaProvider } from './context/MediaContext'
import { TranscriptProvider } from './context/TranscriptContext'
import VideoRoomPage from './videoCallPages/VideoRoomPage'

/**
 * Main Video Call Page Component
 * Provides all necessary contexts for video call functionality
 */
export default function VideoCallPage() {
  return (
    <RoomProvider>
      <MediaProvider>
        <TranscriptProvider>
          <VideoRoomPage />
        </TranscriptProvider>
      </MediaProvider>
    </RoomProvider>
  )
}

